import axios from 'axios';
import { envName } from '../components/Common/const';
const url = 'https://ipapi.co/json/';

const apiCall = async function () {
  const response = await axios
    .get(url)
    .then(response => {
      if (response && response.data && response.data.ip) return response.data.ip;
    })
    .catch(err => {
      if (envName !== 'production') {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    });
  return response;
};

export default apiCall;
